import { Box, ScrollArea, Table } from "@mantine/core";
import cx from "clsx";
import { useEffect, useState } from "react";
import { repositoryPos } from "../../../../../../_base/_const/_constVar";
import { MessageResponse } from "../../../../../../model/MessageResponse";
import {
  listBranch,
  tblPromotionDetailModel,
} from "../../../../../../model/TblPromotion";
import {
  branchMasterItem,
  parseListBranch,
  toBranchRows,
} from "../../../../../../helpers/promotionBranchHelper";
import classes from "../../Styles/ScrollTable.module.css";

const SuperMarket = ({
  dataPromotionDetail,
}: {
  dataPromotionDetail: tblPromotionDetailModel | undefined;
}) => {
  const [dataTable, setDataTable] = useState<listBranch[]>([]);
  const [dataBranch, setDataBranch] = useState<branchMasterItem[]>([]);
  const [scrolled, setScrolled] = useState(false);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    const fetchDataBranch = async () => {
      const dataApi = await repositoryPos.get<MessageResponse<any>>(
        "/api/v1/TblDmInventory/get-select-branch"
      );

      if (dataApi && dataApi.success) {
        setDataBranch(dataApi.data);
      }
    };

    fetchDataBranch();
  }, []);

  useEffect(() => {
    // Chính sách chỉ lưu id chi nhánh, mã và tên bù lại từ danh mục
    setDataTable(
      toBranchRows(
        parseListBranch(dataPromotionDetail?.listBranch),
        dataBranch
      )
    );
  }, [dataPromotionDetail, dataBranch]);

  useEffect(() => {
    const handleResize = () => {
      setHeight(window.innerHeight - 485);
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);

  return (
    <Box mt={10}>
      <ScrollArea
        h={height}
        onScrollPositionChange={({ y }) => setScrolled(y !== 0)}
      >
        <Table
          withColumnBorders
          withTableBorder
          style={{ overflowY: "auto", height: "30px" }}
        >
          <Table.Thead
            className={cx(classes.header, { [classes.scrolled]: scrolled })}
          >
            <Table.Tr>
              <Table.Th w={140}>Mã chi nhánh</Table.Th>
              <Table.Th>Tên chi nhánh</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody mih={100}>
            {dataTable?.map((branch) => (
              <Table.Tr key={branch.id}>
                <Table.Td>{branch.code}</Table.Td>
                <Table.Td>{branch.branchName}</Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
          {dataTable.length < 1 && (
            <Table.Caption>Không có dữ liệu</Table.Caption>
          )}
        </Table>
      </ScrollArea>
    </Box>
  );
};

export default SuperMarket;
